import React, { useContext, useState, useEffect } from "react";
import styles from "./Faqs_Ques.module.css";
import { LanguageContext } from "../../Component/LanguageContext/LanguageContext";
import axios from "axios";

const Faqs_Ques = () => {
  const marketingBackendUrl = import.meta.env.VITE_MARKETING_BACKEND_URL;
  const [openTitleIndices, setOpenTitleIndices] = useState([]);
  const [openQuestionIndices, setOpenQuestionIndices] = useState([]);
  const [faqData, setFaqData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { direction } = useContext(LanguageContext);
  const isRTL = direction === "rtl";

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchFaqs = async () => {
      try {
        const response = await axios.get(`${marketingBackendUrl}/maflam/faqpage`);
        // Sort by displayOrder
        const sortedData = response.data.sort((a, b) => a.displayOrder - b.displayOrder);
        setFaqData(sortedData);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchFaqs();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading data</p>;

  const toggleItem = (setter, index, key = null) => {
    const toggleKey = key ?? index;
    setter((prev) =>
      prev.includes(toggleKey) ? prev.filter((i) => i !== toggleKey) : [...prev, toggleKey]
    );
  };

  const renderSubQuestions = (subQuestions, sectionIndex) => {
    return subQuestions
      .sort((a, b) => a.displayOrder - b.displayOrder)
      .map((item, questionIndex) => {
        const questionText = isRTL ? item.questionArab : item.questionEng;
        const answerText = isRTL ? item.answerArab : item.answerEng;
        const questionKey = `${sectionIndex}-${questionIndex}`;

        return (
          <div key={questionIndex} className={styles.faqItem}>
            <div
              className={styles.questionContainer}
              onClick={() => toggleItem(setOpenQuestionIndices, null, questionKey)}
            >
              <span className={styles.questionToggleSign}>
                {openQuestionIndices.includes(questionKey) ? "-" : "+"}
              </span>
              <h3 className={styles.question}>{questionText}</h3>
            </div>
            <div
              className={styles.answer}
              style={{
                maxHeight: openQuestionIndices.includes(questionKey) ? "200px" : "0px",
                overflow: "hidden",
                transition: "max-height 0.3s ease",
              }}
            >
              <p>{answerText}</p>
            </div>
          </div>
        );
    });
  };

  return (
    <div className={styles.mainContainers}>
      <div className={styles.faqContainer}>
        <h1 className={styles.title}>{isRTL ? "الأسئلة الشائعة" : "FAQ"}</h1>
        {faqData.map((section, sectionIndex) => {
          if (!section.isActive) return null;

          const mainQuestion = isRTL ? section.mainQuestionArab : section.mainQuestionEng;
          const mainAnswer = isRTL ? section.mainAnswerArab : section.mainAnswerEng;

          return (
            <div key={sectionIndex}>
              <div
                className={styles.titleContainer}
                onClick={() => toggleItem(setOpenTitleIndices, sectionIndex)}
              >
                <span className={styles.sectionToggleSign}>
                  {openTitleIndices.includes(sectionIndex) ? "-" : "+"}
                </span>
                <h2 className={styles.sectionTitle}>{mainQuestion}</h2>
              </div>

              {openTitleIndices.includes(sectionIndex) && (
                <>
                  {mainAnswer && (
                    <div className={styles.answer} style={{ maxHeight: "200px" }}>
                      <p>{mainAnswer}</p>
                    </div>
                  )}
                  {renderSubQuestions(section.subQuestions, sectionIndex)}
                </>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Faqs_Ques;
